import { Component, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, TemplateRef, inject, WritableSignal, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AdminService } from 'src/app/services/admin/admin.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { faApple, faGoogle, faMicrosoft } from '@fortawesome/free-brands-svg-icons'
import { CommonModule } from '@angular/common';
import { HeaderAuthComponent } from 'src/app/components/layout/header-auth/header-auth.component';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HeaderAuthComponent,
    RouterModule
  ],
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInComponent implements OnInit {
  validateForm!: FormGroup;

  faApple = faApple
  faGoogle = faGoogle
  faMicrosoft = faMicrosoft
 

  constructor(
    private fb: FormBuilder,
    public admin: AdminService,
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguagesService,
    private cdr: ChangeDetectorRef
  ) {}


  ngOnInit(): void {
    if (this.admin.isAdmin()) {
      this.router.navigate(['']);
    }

    this.validateForm = this.fb.group({
      user: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]]
    });
  
  }

  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls.hasOwnProperty(i)) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  
    const data = {
      user: this.validateForm.value.user,
      password: this.validateForm.value.password
    };
  
    if (!this.admin.isAdmin()) {
      this.admin.login(data)
        .then((isSuccess) => {
          if (isSuccess) {
            // წარმატებული ავტორიზაცია
            // მაგალითად, შეგიძლიათ აქ დაამატოთ სხვა ლოგიკა
            this.router.navigate([], { queryParams: { checkverify: 'true' }, queryParamsHandling: 'merge' });
          }
        })
        .catch((error) => {
          // შეცდომის დამუშავება
          console.log('Login error:', error);
        })
        .finally(() => {
          this.admin.loading = false;
          this.cdr.detectChanges(); // UI-ს განახლება, რათა Angular იცოდეს, რომ loading შეიცვალა
        });
    }
  }




 




}